export * from './NftDetailsInfoBlock';
